module.exports = __webpack_public_path__ + "img/ts-162x230.ff6687f2.jpg";